/**
 * Checks if OneTrust active groups contains C0004 (Targeting Cookies)
 * @returns true if C0004 is present in the active groups, false otherwise
 */
const hasTargetingCookieConsent = (): boolean => {
  const activeGroups = globalThis.OnetrustActiveGroups || ''
  return activeGroups.includes('C0004')
}

export default hasTargetingCookieConsent
